/**
 * Normalizes IDs to be formatted as 'INV-' + 8-digit zero-padded number.
 * Matches the formatting used in the inventory_with_formatted_id view.
 * @param {string|number} id
 * @returns {string} Formatted ID like 'INV-00000123'
 */
export function normalizeId(id) {
  if (!id) return "";

  let idString = String(id);

  const zerosToAdd = Math.max(0, 8 - idString.length);

  return "INV-" + "0".repeat(zerosToAdd) + idString;
}
